interface RouteConfig {
  INDEX: string;
  addSlug?: (url: string, id: string) => string;
}

const HOME: RouteConfig = {
  INDEX: "/",
};

const REGISTER: RouteConfig = {
  INDEX: "/register",
};

const PROFILE: RouteConfig = {
  INDEX: "/profile/:nft_id",
  addSlug: (url: string, nft_id: string): string => {
    return url.replace(":nft_id", nft_id);
  },
};

const CENTRAL: RouteConfig = {
  INDEX: "/central",
};

const GBET_ROUTE: RouteConfig = {
  INDEX: "/gbet-token",
};

const LEADERSHIP: RouteConfig = {
  INDEX: "/leaderboard",
};

const MARKET_PLACE: RouteConfig = {
  INDEX: "/marketplace",
};

const MIGRATION: RouteConfig = {
  INDEX: "/migration",
};

const WALLET: RouteConfig = {
  INDEX: "/wallet/:id",
  addSlug: (url: string, id: string): string => {
    return url.replace(":id", id);
  },
};

// const CROWN_REDEMPTION: RouteConfig = {
//   INDEX: "/crown",
// };

const PRESALE: RouteConfig = {
  INDEX: "/presale",
};

const FAQ_ROUTE: RouteConfig = {
  INDEX: "/faq",
};

const ACTIVITY_LOG: RouteConfig = {
  INDEX: "/activity",
};

const ILLUSTRATION_GALLERY: RouteConfig = {
  INDEX: "/illustration-gallery",
};

const ERROR_404: RouteConfig = {
  INDEX: "/404",
};

export {
  HOME,
  CENTRAL,
  PROFILE,
  GBET_ROUTE,
  ACTIVITY_LOG,
  LEADERSHIP,
  MARKET_PLACE,
  WALLET,
  PRESALE,
  FAQ_ROUTE,
  REGISTER,
  ILLUSTRATION_GALLERY,
  ERROR_404,
  MIGRATION
}; 